var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.selItems,"persistent-hint":"","outlined":"","dense":"","menu-props":{ maxHeight: '200px', bottom: '100px' }},model:{value:(_vm.selDatas),callback:function ($$v) {_vm.selDatas=$$v},expression:"selDatas"}})
}
var staticRenderFns = []

export { render, staticRenderFns }